/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { SVGIcon, theme } from "@nordcloud/gnui";
import { showSuccess } from "~/services/toast";
import { interactiveCss } from "~/styles";
import { CopyToClipboard } from "./CopyToClipboard";

const StyledCode = styled.code({
  background: theme.color.background.ui04,
  borderRadius: theme.radiusDefault,
  position: "relative",
  display: "block",
  minHeight: theme.spacing.spacing07,
  padding: theme.spacing.spacing02,
  paddingRight: theme.spacing.spacing08,
  whiteSpace: "pre",
  maxWidth: "100%",
  maxHeight: "400px",
  overflow: "scroll",
});

type Props = {
  children: string;
  successMessage?: string;
};

export function CopyCode({ children, successMessage = "Code Copied" }: Props) {
  return (
    <StyledCode>
      {children}
      <CopyToClipboard text={children.toString()} onCopy={() => showSuccess(successMessage)}>
        <SVGIcon
          name="copy"
          css={[
            {
              position: "absolute",
              right: theme.spacing.spacing02,
              top: theme.spacing.spacing02,
            },
            interactiveCss,
          ]}
        />
      </CopyToClipboard>
    </StyledCode>
  );
}
